export const FILE_TREE = {
  FILE_TREE_QUEUE: 'queue',
  FILE_TREE_FILES: 'files',
  FILE_TREE_TRASH: 'trash',
  FILE_TREE_DEADLINES: 'deadlines',
  FILE_TREE_INBOX: 'inbox',
  FILE_TREE_SHARES: 'shares',
}
